import { GetSessionData as DLGetSessionData, UpdateSessionData as DLUpdateSessionData, DeleteSessionData as DLDeleteSessionData } from './../DL/Sessions'


const GetSessionData = async (isAdmin = false) => {
    try {
        const response = await DLGetSessionData(isAdmin)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: null }
    }
}

const UpdateSessionData = async (userData, isAdmin = false) => {
    try {
        const response = await DLUpdateSessionData(userData, isAdmin)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: null }
    }
}

const DeleteSessionData = async (isAdmin = false) => {
    try {
        const response = await DLDeleteSessionData(isAdmin)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: null }
    }
}

export { GetSessionData, UpdateSessionData, DeleteSessionData };